/**
 * Platform admin hub API client
 */
import { apiJson } from './apiClient';

export interface AdminUserRow {
  id: string;
  email: string;
  role: string;
  createdAt?: string;
  lastLogin?: string | null;
  disabledAt?: string | null;
  disabledReason?: string | null;
  isDisabled: boolean;
}

export async function adminGetPlatformStats() {
  return apiJson<{
    success: boolean;
    stats: { users: number; projects: number; layers: number; disabledUsers: number };
  }>('/api/admin/platform/stats');
}

export async function adminListUsers(q?: string) {
  const qs = q ? `?q=${encodeURIComponent(q)}` : '';
  return apiJson<{ success: boolean; users: AdminUserRow[]; count: number }>(
    `/api/admin/platform/users${qs}`
  );
}

export async function adminDisableUser(id: string, reason?: string) {
  return apiJson(`/api/admin/platform/users/${id}/disable`, {
    method: 'POST',
    body: { reason },
    retry: false,
  });
}

export async function adminEnableUser(id: string) {
  return apiJson(`/api/admin/platform/users/${id}/enable`, {
    method: 'POST',
    body: {},
    retry: false,
  });
}

export async function adminUnpublishShare(layerId: string) {
  return apiJson(`/api/admin/platform/shares/${layerId}/unpublish`, {
    method: 'POST',
    body: {},
    retry: false,
  });
}

export async function adminPublishShare(layerId: string) {
  return apiJson(`/api/admin/platform/shares/${layerId}/publish`, {
    method: 'POST',
    body: {},
    retry: false,
  });
}

export async function adminGetFunnelSummary(days = 7) {
  return apiJson<{
    success: boolean;
    days: number;
    uniqueSessions: number;
    byEvent: Record<string, number>;
    funnel: {
      map_open: number;
      pricing_view: number;
      lead_submit: number;
      map_to_pricing_pct: number | null;
      pricing_to_lead_pct: number | null;
    };
  }>(`/api/events/admin/summary?days=${days}`);
}
